import { useState } from 'react'
import { useToggle } from 'shared/hooks'

import { TechnicianScheduleForm } from 'domains/serviceOrders/screens/CalendarBlocking/schemas/technicianScheduleForm'
import Form from 'domains/serviceOrders/screens/CalendarBlocking/components/Form'
import ScheduleBlockCard from '../ScheduleBlockCard'
import { ButtonV2, Drawer, Text } from 'components'

import { TechnicianScheduleResponse } from 'services/technicianSchedule/types'

import styles from './styles.module.scss'

interface CalendarBlockingDrawer {
  technician: {
    id?: string
    name?: string
  }
  technicianSchedules?: TechnicianScheduleResponse[]
}

const CalendarBlockingDrawer = ({
  technicianSchedules,
  technician,
}: CalendarBlockingDrawer) => {
  const [selectedTechnicianSchedulePause, setSelectedTechnicianSchedulePause] =
    useState<TechnicianScheduleForm | undefined>()
  const formModal = useToggle()
  return (
    <>
      {formModal.isVisible && (
        <Form
          isVisible
          onSave={formModal.hide}
          onClose={formModal.hide}
          data={selectedTechnicianSchedulePause}
          technicianScheduleId={selectedTechnicianSchedulePause?.id}
        />
      )}
      <Drawer.Root>
        <div className={styles.trigger}>
          <Drawer.Trigger>
            <ButtonV2 appearance="tertiary" color="yellow">
              Visualizar
            </ButtonV2>
          </Drawer.Trigger>
        </div>

        <Drawer.Content position="right">
          <div className={styles.drawer}>
            <Drawer.Title>
              Bloqueio de agenda
              <Drawer.Close />
            </Drawer.Title>
            <div className={styles.wrapper}>
              <div>
                <Text color="element-medium" size="sm">
                  Técnico
                </Text>
                <Text color="element-default" size="md" weight="regular">
                  {technician?.name}
                </Text>
              </div>

              <ul>
                {technicianSchedules?.map((schedule) => (
                  <ScheduleBlockCard
                    key={schedule.id}
                    schedule={schedule}
                    onEdit={() => {
                      setSelectedTechnicianSchedulePause({
                        id: schedule.id,
                        reason: schedule.reason,
                        technician: {
                          id: technician.id ?? schedule.technicianId,
                          name: technician.name ?? '',
                        },
                        startDate: schedule.startDate,
                        endDate: schedule.endDate,
                        note: schedule.note || '',
                      })
                      formModal.show()
                    }}
                  />
                ))}
              </ul>
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Root>
    </>
  )
}

export default CalendarBlockingDrawer
